import * as CookieConsent from 'vanilla-cookieconsent/dist/core/cookieconsent-core.esm.js';
import WbsToggleCookieModal from "./WbsToggleCookieModal";


const WbsCookies = () => {
    const cc = CookieConsent;
    const btnEssential = document.getElementById('WbsCookieBtnEssential');
    const btnAll = document.getElementById('WbsCookieBtnAcceptAll');
    const btnAcceptSelected = document.getElementById('WbsCookieBtnAcceptSelected');
    const analyticsCookiesCheck = document.getElementById('WbsAnalyticsCookies');
    const adsCookiesCheck = document.getElementById('WbsAddsCookies');
    const additionalCookiesCheck = document.getElementById('WbsAdditionalCookies');
    const cookieData = window.wbs_cookie_data;
    for (let category in cookieData) {
        cookieData[category].autoClear.cookies.forEach(cookie => {
            // Check if the string starts and ends with "/" to identify regex patterns
            if (cookie.name.startsWith('/') && cookie.name.endsWith('/')) {
                // Remove the starting and ending slashes
                let regexPattern = cookie.name.slice(1, -1);
                cookie.name = new RegExp(regexPattern);
            }
        });
    }

    const categories = {
        necessary: {
            readOnly: true,
            enabled: true,
        },
        ...cookieData
    };

    cc.run({
        categories,

        onFirstConsent: ({cookie}) => {

        },

        onConsent: ({cookie}) => {

        },

        onChange: ({cookie, changedCategories}) => {

        },
    }).then(() => {
        /**
         * Show dialog if
         * consent is not valid
         */
        if (!cc.validConsent()) {
            WbsToggleCookieModal('show');
        }

    });

    btnEssential.addEventListener('click', () => {
        cc.acceptCategory([]);
        WbsToggleCookieModal('hide');
    });

    btnAll.addEventListener('click', () => {
        cc.acceptCategory('all');
        WbsToggleCookieModal('hide');
    });


    btnAcceptSelected.addEventListener('click', () => {
        const accepted = [];

        if (analyticsCookiesCheck !== null && analyticsCookiesCheck.checked) {
            accepted.push('analytics')
        }

        if (adsCookiesCheck !==null && adsCookiesCheck.checked) {
            accepted.push('ads')
        }

        if (additionalCookiesCheck !==null && additionalCookiesCheck.checked) {
            accepted.push('additional')
        }

        cc.acceptCategory(accepted);

        WbsToggleCookieModal('hide');


    });
}


export default WbsCookies;